
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Loader from 'react-loader-spinner';
import { connect } from 'react-redux';
import { AdminUserAction, AlertAction, ProductAction, RayCodeAction } from '../../actions';
import { RayDataAction } from '../../actions/RayDataAction';
import { UserType } from '../../config';
import { ORG_HQ, USER_TYPE_DEALER } from '../../config/appConstants';
import { sDeviceModels } from '../../config/RayCodes';
import { Translate as t } from '../../config/Translate';
import { resolveWarrantyType } from '../../lib/warrantyType';
import { formatDisplayDate } from '../../lib/dateDisplay';
import { canApplyWarrantyStandard, canEditManufacturerWarranty, canEditBranchWarranty } from '../../lib/rbacGuard';
import { RayTable } from '../common';
import { ModalConfirm } from '../common/ModalConfirm';
import ProductExtendedWarrantyAdd from './ProductExtendedWarrantyAdd';
import ProductWarrantyAdd from './ProductWarrantyAdd';

const ProductInfoWarranty = ({ product, users, user, codeList, GetUserAll, GetCodeListAll, DeleteExtendedWarranty, ShowSaved }) => {

    const [showModal, setShowModal] = useState(false);
    const [mfWarranty, setMfWarranty] = useState([]);
    const [brWarranty, setBrWarranty] = useState([]);
    const [exWarranty, setExWarranty] = useState([]);
    const [warrantyHistory, setWarrantyHistory] = useState([]);
    const [userType, setUserType] = useState('DEALER');
    const [request, setRequest] = useState(false);
    const [smallDevice, setSmallDevice] = useState(false);
    const [item, setItem] = useState({});
    const [showMfModal, setShowMfModal] = useState(false);
    const [warrantyPreview, setWarrantyPreview] = useState(null);
    const [warrantyApplyError, setWarrantyApplyError] = useState(null);
    const [exToDelete, setExToDelete] = useState(null);
    const [exToEdit, setExToEdit] = useState(null);

    // BUG-167 (B-2): 하드코딩 "CT" 대신 product.model + codeList 로 warranty 제품타입을 도출한다.
    const warrantyType = resolveWarrantyType(product?.model, codeList);

    const getName = (val) => {
        const n = codeList.filter(x => x.type == "WARRANTY" && x.code == val);
        return n.length > 0 ? n[0].name : val;
    }

    const getUserName = (adminId) => {
        const result = users.find(item => item.adminid == adminId);

        if (result?.name)
            return result?.name || '';
        else
            return result?.firstName || '' + result?.lastName || ''
    }

    const applyExWarranty = (category, dest, period) => {
        let applied = period;
        const type = category === "wartype_ms" ? "HQ" : "BRANCH";
        product.exWarranty?.filter(x => !x.isDel).forEach(x => {
            if (x.type === type && x.dest.includes(dest))
                applied = moment(applied).add(x.amount, x.amountType);
        });

        return applied;
    }

    useEffect(() => {
        if(sDeviceModels.find(f => f.code === product?.model)) {
            setSmallDevice(true);
        }
        GetCodeListAll();
        GetUserAll();
    }, []);

    useEffect(() => {
        return () => {
            setShowMfModal(true);
        }
    }, [item]);

    useEffect(() => {
        setMfWarranty(product.waranties.filter(x => x.category == 'wartype_ms'));
        setBrWarranty(product.waranties.filter(x => x.category == 'wartype_bs'));

        const warrantyLog = product.warantylog ? product.warantylog.map(x => {
            const attachment = x.hasOwnProperty("attachment") && x.attachment;
            return {
                date: x.timestamp,
                type: getName(x.category),
                product: x.dest.includes('warproduct_product') ? 'O' : '',
                cbctDetector: x.dest.includes('warproduct_cbct') ? 'O' : '',
                panoDetector: x.dest.includes('warproduct_pano') ? 'O' : '',
                cephDetector: x.dest.includes('warproduct_ceph') ? 'O' : '',
                tubeTank: x.dest.includes('warproduct_tubetank') ? 'O' : '',
                inverterboard: x.dest.includes('warproduct_inverterboard') ? 'O' : '',
                duration: x.amount + " " + (x.amounttype == "d" && t('product.warranty.periodUnitDays') || x.amounttype == "M" && t('product.warranty.periodUnitMonths') || x.amounttype == "y" && t('product.warranty.periodUnitYears')),
                reason: x.why,
                applied: users.find(item => item.adminid === x.who)?.name || '',
                attachmentPath: attachment.length > 0 ? attachment[0].path : "",
                attachmentOrigin: attachment.length > 0 ? attachment[0].origin : ""
            }
        }) : [];

        setWarrantyHistory(warrantyLog.sort((a, b) => {
            const date_1 = new Date(a.date);
            const date_2 = new Date(b.date);

            if (date_1 < date_2) return 1;
            if (date_1 > date_2) return -1;

            return 0;
        }));

        // FEAT-046: dest 별 누적 합산(temp) 대신 개별 이력 항목 단위로 표시한다.
        setExWarranty(
            (product.exWarranty || []).filter(x =>
                x.type === (userType === ORG_HQ ? ORG_HQ : "BRANCH") && x.isDel !== true
            )
        );
    }, [product, userType])

    useEffect(() => {
        setUserType(UserType(user.companyId, user?.companyInfo?.org));
    }, [user]);

    // IMP-342 (C-6, PR-2): 즉시 apply 대신 preview 요청 → 확인모달 → apply 2단계로 전환.
    // FEAT-042 (D-2): category 파라미터화 — HQ(Manufacturer)/BRANCH 공용 진입점.
    const requestWarrantyPreview = async (category = 'HQ') => {
        setRequest(true);

        const response = await RayDataAction.SetWarranty(product.sn, category, warrantyType, true);

        setRequest(false);

        if (response?.status === 'fail') {
            // preview 요청 자체가 실패한 경우도 무음 처리하지 않고 오류로 노출한다.
            setWarrantyPreview(null);
            setWarrantyApplyError({ reason: response?.reason });
            return;
        }

        const payload = response?.data || {};
        setWarrantyApplyError(null);
        setWarrantyPreview({
            category,
            matched: !!payload.matched,
            computed: Array.isArray(payload.computed) ? payload.computed : [],
            current: Array.isArray(payload.current) ? payload.current : [],
        });
    }

    const confirmWarrantyApply = async () => {
        setRequest(true);

        const category = warrantyPreview?.category || 'HQ';
        const response = await RayDataAction.SetWarranty(product.sn, category, warrantyType, false);

        setRequest(false);

        const applied = response?.data;
        if (response?.status === 'success' && Array.isArray(applied?.waranties)) {
            ShowSaved();
            if (category === 'HQ') {
                setMfWarranty(applied.waranties.filter(x => x.category == 'wartype_ms'));
            } else {
                setBrWarranty(applied.waranties.filter(x => x.category == 'wartype_bs'));
            }
            setWarrantyPreview(null);
            setWarrantyApplyError(null);
            return;
        }

        // apply 실패(예: 409 WARRANTY_POLICY_NOT_MATCHED) — mfWarranty/brWarranty 는 갱신하지 않고, preview 모달을 닫고 오류를 표시한다 (무음삭제 방지).
        setWarrantyPreview(null);
        setWarrantyApplyError({ reason: response?.reason });
    }

    const closeWarrantyPreview = () => setWarrantyPreview(null);

    const warranty_history_header = [
        { name: 'date', label: t('common.field.date'), type: 'DT' },
        { name: 'type', label: t('common.field.type') },
        { name: 'product', label: t('product.title'), type: 'TF', align: 'text-center', tfStyle: 'neutral' },
        { name: 'cbctDetector', label: t('product.part.cbctDetector'), type: 'TF', align: 'text-center', tfStyle: 'neutral' },
        { name: 'panoDetector', label: t('product.part.panoDetector'), type: 'TF', align: 'text-center', tfStyle: 'neutral' },
        { name: 'cephDetector', label: t('product.part.cephDetector'), type: 'TF', align: 'text-center', tfStyle: 'neutral' },
        { name: 'tubeTank', label: t('product.part.tubeTank'), type: 'TF', align: 'text-center', tfStyle: 'neutral' },
        { name: 'inverterboard', label: t('product.part.inverterBoard'), type: 'TF', align: 'text-center', tfStyle: 'neutral' },
        { name: 'applied', label: t('raydata.report.applied') },
        { name: 'duration', label: t('common.field.duration') },
        { name: 'reason', label: t('common.field.reason') },
        { name: 'attachment', label: t('common.label.attachments'), type: 'DOWNLOADBUTTON' },
    ];

    const warranty_history_header_smallDevice = [
        { name: 'date', label: t('common.field.date'), type: 'DT' },
        { name: 'type', label: t('common.field.type') },
        { name: 'product', label: t('product.title'), type: 'TF', align: 'text-center', tfStyle: 'neutral' },
        { name: 'applied', label: t('raydata.report.applied') },
        { name: 'duration', label: t('common.field.duration') },
        { name: 'reason', label: t('common.field.reason') },
        { name: 'attachment', label: t('common.label.attachments'), type: 'DOWNLOADBUTTON' },
    ]

    const upgradeKitWarranties = product.waranties.filter(
        x => x.dest === 'warproduct_upgradekit' && x.category === (userType === ORG_HQ ? 'wartype_ms' : 'wartype_bs')
    );

    return (
        <div className="row mb-1 p-2">
            {
                // SEC-040 B-1: 제조사 보증 실행 버튼 — 개인계정 하드코딩 제거, adminType=S + isSetWarranty + HQ org 3중 게이트(BE postSetWarranty 게이트와 정합).
                canApplyWarrantyStandard({ adminType: user?.adminType, isSetWarranty: user?.isSetWarranty, org: user?.companyInfo?.org, category: 'HQ' }) &&
                <div style={{ textAlign: 'right' }}>
                    <button className='btn btn-primary btn-sm mt-0' type="button" onClick={() => requestWarrantyPreview('HQ')} disabled={request}>
                    <Loader
                                type='TailSpin'
                                color='#fff'
                                width={15}
                                height={15}
                                visible={request}
                                radius={2}
                                style={{ display: 'inline-block', marginRight: '10px' }} />
                        {t('warranty.button.applyManufacturerStandard')}
                        </button>
                </div>
            }

            {
                // FEAT-042 (D-2): Branch 조직의 자사 보증 표준 적용 버튼 — HQ 게이트와 동일 패턴, category만 BRANCH.
                canApplyWarrantyStandard({ adminType: user?.adminType, isSetWarranty: user?.isSetWarranty, userType, category: 'BRANCH' }) &&
                <div style={{ textAlign: 'right' }}>
                    <button className='btn btn-primary btn-sm mt-0' type="button" onClick={() => requestWarrantyPreview('BRANCH')} disabled={request}>
                    <Loader
                                type='TailSpin'
                                color='#fff'
                                width={15}
                                height={15}
                                visible={request}
                                radius={2}
                                style={{ display: 'inline-block', marginRight: '10px' }} />
                        {t('warranty.button.applyBranchStandard')}
                        </button>
                </div>
            }

            {
                warrantyApplyError &&
                <div className="col-12 alert alert-danger" data-testid="warranty-apply-error">
                    {warrantyApplyError.reason === 'WARRANTY_POLICY_NOT_MATCHED'
                        ? t('warranty.apply.notMatchedError')
                        : t('warranty.apply.applyFailed')}
                </div>
            }

            {
                userType !== USER_TYPE_DEALER &&
                <div className="col m-0 p-1">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title m-0 float-start">{t('warranty.label.manufacturerWarranty')}</div>
                            {
                                (canEditManufacturerWarranty({ userType, adminType: user.adminType }) && product.waranties.filter(x => x.category == 'wartype_ms').length > 0) &&
                                <div className='float-end'><a data-testid="manufacturer-warranty-edit" className='btn btn-sm mt-0 right' onClick={() => setItem({ category: "wartype_ms", whenkey: "warwhen_custom", whykey: "warwhy_custom" })}><ion-icon name="add-circle-outline" ></ion-icon> {t('common.button.edit')}</a></div>
                            }
                        </div>

                        <ul className="listview simple-listview">
                            {
                                mfWarranty.length > 0 && mfWarranty.filter(f => smallDevice ? f?.dest != "warproduct_xray" : true ).map((x, idx) => {
                                    return <li key={`mf_${idx}`} className="border-bottom">
                                        <div>{getName(x.dest)}</div>
                                        <div>
                                            <span>
                                                {formatDisplayDate(applyExWarranty(x.category, x.dest, x.period))}
                                            </span>
                                        </div>
                                    </li>
                                })
                            }
                            {
                                mfWarranty.length == 0 && <div className="card-body">
                                    <h5>{t('common.message.noRecords')}</h5>
                                </div>
                            }
                        </ul>
                    </div>
                </div>
            }

            {
                <div className="col m-0 p-1">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title m-0 float-start">{t(userType !== USER_TYPE_DEALER ? 'branchwarranty' : 'manufacturerwarranty')}</div>
                            {canEditBranchWarranty({ userType, adminType: user.adminType }) &&
                                <div className='float-end'>
                                    <a data-testid="branch-warranty-edit" className='btn btn-sm mt-0 right' onClick={() => setItem({ category: "wartype_bs", whenkey: "warwhen_custom", whykey: "warwhy_custom" })}><ion-icon name="add-circle-outline"></ion-icon> {t('common.button.edit')}</a>
                                </div>
                            }
                        </div>

                        <ul className="listview simple-listview">
                            {
                                brWarranty.length > 0 && brWarranty.map((x, idx) => {
                                    return <li key={`br_${idx}`} className="border-bottom">
                                        <div>{getName(x.dest)}</div>
                                        <div>
                                            <span>
                                                {formatDisplayDate(applyExWarranty(x.category, x.dest, x.period))}
                                            </span>
                                        </div>
                                    </li>
                                })
                            }
                            {
                                brWarranty.length == 0 && <div className="card-body">
                                    <h5>{t('common.message.noRecords')}</h5>
                                </div>
                            }
                        </ul>
                    </div>
                </div>
            }

            <div className="col m-0 p-1">
                <div className="card">
                    <div className="card-header">
                        <div className="card-title m-0 float-start">{t('warranty.label.extendedWarranty')}</div>
                        {
                            // FEAT-046: 확장 워런티는 일반 딜러도 관리 가능 → privilege 게이트 없음(org 스코프+감사 추적이 경계). base 워런티 존재 시 노출.
                            (userType === 'BRANCH'
                                ? product.waranties.filter(x => x.category == 'wartype_bs').length > 0
                                : product.waranties.filter(x => x.category == 'wartype_ms').length > 0) &&
                            <div className='float-end'><a className='btn btn-sm mt-0 right' onClick={() => setShowModal(true)}><ion-icon name="add-circle-outline" ></ion-icon> {t('common.button.add')}</a></div>
                        }
                    </div>

                    <ul className="listview simple-listview">
                        {
                            exWarranty.length > 0 && exWarranty.map((x) => {
                                const durationLabel = x.amountType === 'y' ? t('product.warranty.periodUnitYears') : x.amountType === 'M' ? t('product.warranty.periodUnitMonths') : t('product.warranty.periodUnitDays');
                                return <li key={x._id} className="border-bottom">
                                    <div>{(x.dest || []).map(d => getName(d)).join(', ')}</div>
                                    <div>
                                        <span>{x.amount} {durationLabel}</span>
                                        {/* FEAT-047: 수정도 삭제/Add 와 동일 — privilege 게이트 없음(org 스코프+감사 추적). */}
                                        <a
                                            className='btn btn-sm mt-0'
                                            data-testid={`exwarranty-edit-${x._id}`}
                                            onClick={() => setExToEdit(x)}>
                                            <ion-icon name="create-outline"></ion-icon>
                                        </a>
                                        {/* FEAT-046: 삭제도 Add와 동일 — privilege 게이트 없음(org 스코프+감사 추적). 누가·언제 삭제는 deletedBy/deletedAt 로 기록. */}
                                        <a
                                            className='btn btn-sm mt-0'
                                            data-testid={`exwarranty-delete-${x._id}`}
                                            onClick={() => setExToDelete(x)}>
                                            <ion-icon name="trash-outline"></ion-icon>
                                        </a>
                                    </div>
                                </li>
                            })
                        }

                        {
                            exWarranty.length == 0 && <div className="card-body">
                                <h5>{t('common.message.noRecords')}</h5>
                            </div>
                        }

                    </ul>
                </div>
                {/* {(product.waranties.filter(x => x.category == 'wartype_ms').length > 0 && user.adminType == 'S') && <button className="btn btn-primary btn-block btn-sm" onClick={() => setShowModal(true)}><ion-icon name="add-outline"></ion-icon>{t('common.button.add')}</button>} */}
            </div>

            <div className="col m-0 p-1">
                <div className="card">
                    <div className="card-header">
                        <div className="card-title m-0">{t('warranty.label.upgradeKitWarranty')}</div>
                    </div>

                    <ul className="listview simple-listview" data-testid="upgradekit-list">
                        {
                            upgradeKitWarranties.length > 0 ?
                            upgradeKitWarranties.map((x, idx) => (
                                <li key={`uk_${idx}`} className="border-bottom">
                                    <div>{getName(x.dest)}</div>
                                    <div><span>{formatDisplayDate(applyExWarranty(x.category, x.dest, x.period))}</span></div>
                                </li>
                            ))
                            :
                            <li><h5>{t('common.message.noRecords')}</h5></li>
                        }
                    </ul>
                </div>
            </div>

            <div className="card">
                <div className="card-header">
                    <div className="card-title m-0">{t('warranty.label.warrantyHistory')}</div>
                </div>
                <div className="card-body">
                    <RayTable
                        data={warrantyHistory}
                        onlytable={true}
                        columns={smallDevice ? warranty_history_header_smallDevice : warranty_history_header}

                        options={{
                            keyCol: "_id",
                            filterColumns: [],
                        }} />
                </div>
            </div>

            <ProductExtendedWarrantyAdd
                showModal={showModal || !!exToEdit}
                editItem={exToEdit}
                codeList={codeList}
                callbackClose={() => { setShowModal(false); setExToEdit(null); }} />
            <ProductWarrantyAdd
                        data={item}
                        codeList={codeList}
                        showModal={showMfModal}
                        callbackClose={(e) => { setShowMfModal(false) }} />

            {
                warrantyPreview &&
                <ModalConfirm
                    info={{
                        showModal: true,
                        title: t('warranty.apply.confirmTitle'),
                        content: <div>
                                {
                                    warrantyPreview.matched === false
                                    ? <div className="alert alert-warning" data-testid="warranty-preview-nomatch-warning">
                                        {t('warranty.apply.noMatch')}
                                      </div>
                                    : <>
                                        <p>{t('warranty.apply.confirmMessage')}</p>
                                        <table className="table table-sm" data-testid="warranty-preview-diff">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>{t('warranty.apply.currentLabel')}</th>
                                                    <th></th>
                                                    <th>{t('warranty.apply.computedLabel')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.from(new Set([
                                                    ...(warrantyPreview.current || []).map(c => c?.dest),
                                                    ...(warrantyPreview.computed || []).map(c => c?.dest),
                                                ].filter(Boolean))).map((dest, idx) => {
                                                    const curItem = (warrantyPreview.current || []).find(c => c?.dest === dest);
                                                    const compItem = (warrantyPreview.computed || []).find(c => c?.dest === dest);
                                                    const curDate = formatDisplayDate(curItem?.period);
                                                    const compDate = formatDisplayDate(compItem?.period);
                                                    const willRemove = !!curItem && !compItem;
                                                    const isChanged = !!curItem && !!compItem && curItem.period !== compItem.period;
                                                    return <tr key={`warPreviewRow_${idx}`}>
                                                        <td>{getName(dest)}</td>
                                                        <td className={isChanged ? 'text-primary' : ''}>{curDate}</td>
                                                        <td>{'→'}</td>
                                                        <td className={isChanged ? 'text-primary fw-bold' : ''}>
                                                            {willRemove
                                                                ? <span className="text-danger">{t('warranty.apply.willRemoveWarning')}</span>
                                                                : compDate}
                                                        </td>
                                                    </tr>;
                                                })}
                                            </tbody>
                                        </table>
                                        <button
                                            type="button"
                                            className="btn btn-block btn-primary"
                                            data-testid="warranty-apply-confirm-btn"
                                            disabled={request}
                                            onClick={() => confirmWarrantyApply()}>
                                            {t('warranty.apply.applyButton')}
                                        </button>
                                      </>
                                }
                              </div>,
                        actions: [],
                    }}
                    callbackClose={closeWarrantyPreview} />
            }

            {
                exToDelete &&
                <ModalConfirm
                    info={{
                        showModal: true,
                        title: t('warranty.delete.confirmTitle'),
                        content: <div>
                                    <p>{t('warranty.delete.confirmMessage')}</p>
                                    <button
                                        type="button"
                                        className="btn btn-block btn-danger"
                                        data-testid={`exwarranty-delete-confirm-${exToDelete._id}`}
                                        onClick={() => {
                                            DeleteExtendedWarranty(product.sn, exToDelete._id);
                                            setExToDelete(null);
                                        }}>
                                        {t('common.button.delete')}
                                    </button>
                                  </div>,
                        actions: [],
                    }}
                    callbackClose={() => setExToDelete(null)} />
            }
        </div>
    )
};


const mapState = (state) => {
    const product = state.ProductReducer.product;
    const users = state.AdminUserReducer.users;
    const user = state.AuthReducer.user;
    const codeList = state.RayCodeReducer.items;
    return { product, users, user, codeList };
};

const mapDispatch = (dispatch) => ({
    GetUserAll: () => dispatch(AdminUserAction.GetUserAll()),
    GetCodeListAll: () => dispatch(RayCodeAction.GetAll()),
    SetProductWarranty: (sn, data) => dispatch(ProductAction.SetProductWarranty(sn, data)),
    DeleteExtendedWarranty: (sn, exId) => dispatch(ProductAction.DeleteExtendedWarranty(sn, exId)),
    ShowSaved: () => dispatch(AlertAction.Success(t('common.message.success.saved'))),
});

export default connect(mapState, mapDispatch)(ProductInfoWarranty);
